import { useEffect, useState } from 'react';

import WebbLoader from './webb-loader';
import avtx from '../media/user.png'

import {WebbSearchWorker} from '../services/webb-search';

const mode = [{code: 'wrkr', name: 'Delivery Agent'}, {code: 'item', name:'Shipment'}]

export default function WebbSearchModule() {

  const [text, setText] = useState('');
  const [form, setForm] = useState(false);
  const [loading,setLoading]=useState(false);

  const [data, setData] = useState({
    mode: '',
    srch: '',
  })

  const [info, setInfo] = useState({name:'***', crts:'***', stat:'***', avtr:avtx})

  // form validation
  useEffect( () => {
    setForm(false)
    if (data.mode !=='' && data.srch !== '') 
      setForm(true);
  },[data]);

  const handleChange = async(key, val) => {
    setData({ ...data, [key]: val });
  }

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    console.log ({...data})

    if (data.mode==="wrkr") {
      const response = await WebbSearchWorker(JSON.stringify({
        body: { srch: data.srch },
        user: { usid: 'xx', form:'xx' }
      }))
      console.log (response)
      if (response.data) setInfo(response.data)
      else setInfo ({name:'not found', crts:'not found', stat:'not found', avtr:avtx})

    }


    setLoading(false);
  }

  return (
    <>
      <form onSubmit={handleSubmit}>

        <div className="mb-3">
          <label className="form-label small">Search Option <span className="text-danger">*</span></label>
          <select 
            className="form-select height-md"
            value={data.mode}
            onChange={({ target }) => { handleChange("mode", target.value) }}>
            <option value=''>Select Option</option>
            {mode.map((item,i) => (
              <option key={i} value={item.code}>{item.name}</option>
            ))}
          </select>
        </div>

        <div className="mb-3">
          <label className="form-label small">Tracking or Mobile Number <span className="text-danger">*</span></label>
          <input 
            type="search"     
            className="form-control height-md"   
            value={data.srch}
            onChange={({ target }) => {handleChange("srch", target.value); setText('');}}
            placeholder="0123456789">
          </input>
        </div>

        <div className="">
          <div className="d-grid">
            <button className={`btn height-md ${ form ? 'btn-primary' : 'btn-light'}`}
              disabled={!form}
            ><small>Search</small>
            </button>
          </div>
        </div>

      </form>


      <div className="py-3">
        <hr></hr>
      </div>

      <p className="lead fw-bold">Search Results</p>
      <div className={loading ? '' : 'd-none'}>
        <p>Please Wait...</p>
      </div>

      <div className={loading ? 'd-none' : ''}>

        <div className="rounded border p-3 bg-white d-flex">
          <div className="me-auto">
            <p>Name: {info.name}</p>
            <p>Joined: {info.crts}</p>
            <p>Status: {info.stat}</p>
          </div>
          <div className="" style={{width:'100px', height:'100px'}}>
            <img src={info.avtr} alt='...' className="img-fluid" ></img>
          </div>
        </div>

      </div>

    </>
  )
}